module.exports = __webpack_public_path__ + "media/packs/images/document-needed-a3ec0a8c51545664a75f75fa074fee25.svg";